import React, { useEffect, useState } from "react";
import { Container, Grid, Card, CardContent, Typography, CircularProgress } from "@mui/material";
import {Organization_summary} from "../../../hooks/useOrgSummary";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import MDButton from "../../../components/MDButton";
import {useAuth} from "context/AuthContext";

// Define TypeScript types
interface PricingPlan {
    plan_name: string;
    base_fee: string;
    per_sensor_fee: string;
}

interface BillingGroup {
    group_name: string;
    locations: string[];
    overall_subscription_status: string;
    payment_method_status: string;
    customer_portal_url?: string; // Optional in case it's not available
}

const Billing_dashboard: React.FC = () => {
    const [pricingPlan, setPricingPlan] = useState<PricingPlan | null>(null);
    const [billingGroups, setBillingGroups] = useState<BillingGroup[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const { sessionToken } = useAuth();
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

    useEffect(() => {
        // Fetch Pricing Plan
        fetch(`${API_BASE_URL}/account/pricing_plan`, {
            headers: {
                'Authorization': `Bearer ${sessionToken}`,
                'Content-Type': 'application/json'
            }
        })
            .then((response) => response.json())
            .then((data) => setPricingPlan(data[0])) // Assuming first object is the pricing plan
            .catch((error) => console.error("Error fetching pricing plan:", error));

        // Fetch Billing Groups
        fetch(`${API_BASE_URL}/account/billing_status?`, {
            headers: {
                'Authorization': `Bearer ${sessionToken}`,
                    'Content-Type': 'application/json'
            }
        })
            .then((response) => response.json())
            .then((data) => {
                setBillingGroups(data);
                setLoading(false);
            })
            .catch((error) => console.error("Error fetching billing groups:", error));
    }, []);

    return (
        <DashboardLayout>
            <Container maxWidth="md" sx={{ mt: 4 }}>
                <Grid container spacing={3}>
                    {/* Show Loading Indicator */}
                    {loading && <CircularProgress />}

                    {/* Pricing Plan Card */}
                    {pricingPlan && (
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h5" fontWeight="bold">
                                        {pricingPlan.plan_name}
                                    </Typography>
                                    <Typography variant="body1">Base Fee: ${pricingPlan.base_fee} / month</Typography>
                                    <Typography variant="body1">Per Sensor Fee: ${pricingPlan.per_sensor_fee} / month</Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    )}

                    {/* Billing Group Cards */}
                    {billingGroups.map((group, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" fontWeight="bold">
                                        {group.group_name}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary">
                                        Subscription Status: {group.overall_subscription_status}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary">
                                        Payment Status: {group.payment_method_status}
                                    </Typography>
                                    <Typography variant="body2">
                                        Locations: {group.locations.join(", ")}
                                    </Typography>

                                    {/* Manage Billing Button */}
                                    {group.customer_portal_url && (
                                        <MDButton
                                            variant="contained"
                                            color="primary"
                                            href={group.customer_portal_url}
                                            target="_blank"
                                            sx={{ mt: 2 }}
                                        >
                                            Manage Billing
                                        </MDButton>
                                    )}
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </DashboardLayout>

    );
};

export default Billing_dashboard;
